export default (counterDoc, serviceId) => {
  const { byServiceOrderNo, orderNo } = counterDoc.data() || {};

  const currentOrderNo = (byServiceOrderNo && byServiceOrderNo[serviceId]) || orderNo;

  if (currentOrderNo && !isNaN(currentOrderNo)) {
    return String(parseInt(currentOrderNo) + 1).padStart(currentOrderNo.length, "0");
  }
};
